/* AM26 2026-08-05 — show the PDP award badge only over the gallery's opening photo.

   Why this needs JS at all: custom.js:1873 (afterInit) hoists `.s1lb, .label` OUT of
   the swiper and appends them to ul.l4pr, so the badge sits outside the slides and
   would otherwise stay pinned over every photo in the carousel. Nothing on the <ul>
   changes as you scroll, so there is no CSS-only hook. The theme does toggle a
   `.changed` class on slide change, but only for galleries carrying
   .no-thumbs-mobile or .slider-fraction (custom.js:1895) — the PDP gallery has
   neither, so it can't be reused.

   "First photo" = the slide the gallery OPENS on, not index 0. The PDP reads
   data-featured_media_position (main-product.liquid:169) into swiper's initialSlide,
   e.g. LS50 Wireless II opens on index 1. Anchoring to index 0 would hide the badge
   on load, which is the opposite of what's wanted.

   Only touches .l4pr (the PDP gallery). Card badges are unaffected. */
(function () {
	'use strict';

	var POLL_MS = 100;
	var MAX_TRIES = 100; // ~10s, then stop rather than spin forever

	function bindGallery(outer) {
		var gallery = outer.closest ? outer.closest('.l4pr') : null;
		if (!gallery) return true;
		if (!gallery.querySelector('.am-award-badge')) return true; // product has no badge
		if (!outer.swiper) return false; // swiper not created yet — keep polling
		if (outer.amAwardBound) return true;

		outer.amAwardBound = true;
		var swiper = outer.swiper;
		var homeIndex = typeof swiper.params.initialSlide === 'number' ? swiper.params.initialSlide : 0;
		var sync = function () {
			gallery.classList.toggle('am-award-off', swiper.realIndex !== homeIndex);
		};
		swiper.on('slideChange', sync);
		swiper.on('slideChangeTransitionEnd', sync);
		sync();
		return true;
	}

	function scan(tries) {
		var outers = document.querySelectorAll('.l4pr .swiper-outer');
		var allSettled = outers.length > 0;
		Array.prototype.forEach.call(outers, function (outer) {
			if (!bindGallery(outer)) allSettled = false;
		});
		if (!allSettled && tries < MAX_TRIES) {
			setTimeout(function () { scan(tries + 1); }, POLL_MS);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { scan(0); });
	} else {
		scan(0);
	}
})();
